import React from "react";
import { Loader } from "..";
import styles from "./Button.module.css";

function Button(props) {
  if (props.type == "link") {
    return (
      <button {...props} className={`${styles.link}`}>
        {props.content}
      </button>
    );
  }

  return (
    <button
      {...props}
      disabled={props.loading || props.disabled}
      className={`${styles.button} ${props.outlined ? styles.outlined : ""} ${props.className}`}
    >
      {props.loading ? <Loader /> :  props.content}
    </button>
  );
}

export default Button;
